export enum RccapDonorNotReady {    
    DonorRuledOut = 0,
    DonorBackedOut = 1,
    DonorNotReady = 2,
    DonorNotAvailable = 3
}